<template>
  <draggable
    class="drag-ele"
    v-model="myArray"
    ghost-class="ghostClass"
    dragClass="bg-move"
    :forceFallback="true"
    @start="handleStart"
    @end="handleEnd"
    v-bind="{ group: 'title', animation: 150 }"
    @change="handleChange"
    :move="checkMove"
    draggable=".item:not(.fixed-item)"
  >
    <div
      class="item dp-flex justify-btw align-item-c pr"
      :class="{ 'fixed-item': isFixedColumn(item.keyName) }"
      v-for="item in myArray"
      :key="item.keyName"
    >
      <p class="dp-flex align-item-c"><i class="el-icon-rank"></i>{{ item.name }}</p>
      <i
        v-if="!isFixedColumn(item.keyName)"
        class="el-icon-close pa"
        style="top: 6px; right: 10px"
        @click="handleDel(item)"
      ></i>
    </div>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';
export default {
  components: {
    draggable,
  },
  props: {
    initList: { type: Array, default: () => [] },
    // 固定列（不可拖动），从父组件传入
    fixedColumns: { type: Array, default: () => [] },
  },
  data() {
    return {
      drag: true,
      myArray: [],
      moveItem: {},
    };
  },
  methods: {
    handleStart(evt) {
      this.drag = true;
      // console.log("handleStart(evt)", evt);
      if (evt.originalEvent.target.className == 'el-icon-close pa') {
        this.handleDel(this.myArray[evt.oldIndex]);
      }
    },
    handleEnd(evt) {
      this.drag = false;
    },
    handleChange(evt) {
      // console.log("handleChange(evt)", evt);
      // console.log("1-this.myArray", this.myArray);
      // console.log("1-this.myArray", this.myArray.map(i=>i.name));
      // console.log("1-this.initList", this.initList);
      // console.log("1-this.initList", this.initList.map(i=>i.name));
      this.$emit('sort-change', this.myArray);
    },
    handleDel(item) {
      this.$emit('del-item', item);
    },
    // 判断是否为固定列
    isFixedColumn(keyName) {
      return this.fixedColumns.includes(keyName);
    },
    // 检查是否允许移动
    checkMove(evt) {
      const draggedKeyName = evt.draggedContext.element?.keyName;
      // 固定列不能被拖动
      if (this.isFixedColumn(draggedKeyName)) {
        return false;
      }
      // 不能拖动到固定列的位置（前3个位置）
      if (evt.relatedContext.index < this.fixedColumns.length) {
        return false;
      }
      return true;
    },
  },
  watch: {
    initList: {
      handler(val) {
        this.myArray = [...val];
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/commonly';
.drag-ele {
  .item {
    padding: 6px 10px;
    border-bottom: 1px solid rgb(238, 238, 238);
  }
  .el-icon-rank {
    margin-right: 15px;
  }
  .bg-move {
    background-color: rgb(241, 247, 255);
  }
  .ghostClass {
    @extend .bg-theme;
    font-size: 0;
  }
  .fixed-item {
    background-color: #f5f7fa;
    cursor: default;
    opacity: 0.8;
    border-left: 3px solid #409eff;
    p {
      color: #909399;
    }
    .el-icon-rank.disabled-drag {
      color: #dcdfe6;
      cursor: default;
      visibility: hidden;
    }
  }
  .fixed-tag {
    margin-left: 8px;
    font-size: 12px;
    color: #fff;
    background-color: #409eff;
    padding: 2px 6px;
    border-radius: 4px;
    line-height: 1;
  }
}
</style>
